export default [
  {
    _id: 'search-property-001',
    source: 'mock-property',
    name: 'Brooks Household Utility Account',
    relationshipHint: 'Shared utility service with Samuel Brooks',
    reliability: 'supporting',
    city: 'Hutchinson',
    state: 'KS',
    matchingMemberId: 'member-004',
    childId: 'child-001',
    provenance: ['utility-data'],
    confidence: 0.61
  },
  {
    _id: 'search-property-002',
    source: 'mock-property',
    name: 'Johnson Family Parcel',
    relationshipHint: 'Property co-owned by Alicia Johnson and Lydia Brooks',
    reliability: 'verified',
    city: 'Wichita',
    state: 'KS',
    matchingMemberId: null,
    childId: 'child-001',
    provenance: ['assessor-records'],
    confidence: 0.73
  }
];
